'use client';

import LucideIcon from '@/components/ui/LucideIcon';
import { SafeLink } from '@/components/ui/SafeLink';
import { Flex, Heading, Text } from '@skin-seoul/design-system';
import React from 'react';
type Props = {
  href?: string;
  theme?: 'dark' | 'light';
  title: React.ReactNode;
  subtitle?: React.ReactNode;
} & Omit<React.ComponentProps<typeof Flex>, 'title'>;
const SectionHeader = ({
  theme = 'light',
  title,
  subtitle,
  href,
  ...props
}: Props) => {
  const isDark = theme === 'dark';
  return <Flex direction="column" width="100%" gap={2} {...props} data-sentry-element="Flex" data-sentry-component="SectionHeader" data-sentry-source-file="SectionHeader.tsx">
      <Flex asChild gap={4} width={{
      base: '100%',
      tablet: 'fit-content'
    }} data-sentry-element="Flex" data-sentry-source-file="SectionHeader.tsx">
        {href ? <SafeLink unstyled href={href} gap={6} width="100%" display="flex" flexDirection="row" alignItems={{
        base: 'flex-end',
        tablet: 'center'
      }} justifyContent={{
        base: 'space-between',
        mobile: 'start'
      }} color={isDark ? 'generic.0' : 'generic.100'} _hover={{
        '& h2': {
          color: 'primary.400'
        },
        '& svg': {
          color: 'primary.400'
        }
      }} _active={{
        '& h2': {
          color: isDark ? 'primary.200' : 'primary.600'
        },
        '& svg': {
          color: isDark ? 'primary.200' : 'primary.600'
        }
      }}>
            <Heading as="h2" textStyle={{
          base: 'heading.h5.mobile',
          tablet: 'heading.h5'
        }} fontWeight="medium">
              {title}
            </Heading>
            <LucideIcon name="ChevronRight" boxSize={7} />
          </SafeLink> : <Heading as="h2" color={isDark ? 'generic.0' : 'generic.100'} textStyle={{
        base: 'heading.h5.mobile',
        tablet: 'heading.h5'
      }} fontWeight="medium">
            {title}
          </Heading>}
      </Flex>

      <Text color={isDark ? 'neutral.100' : 'neutral.600'} textStyle="paragraph.medium" fontWeight="regular" data-sentry-element="Text" data-sentry-source-file="SectionHeader.tsx">
        {subtitle}
      </Text>
    </Flex>;
};
export default SectionHeader;